import { api } from "./api";

let rerankersPromise;

export async function loadRerankers() {
    rerankersPromise ??= api.getJson("/api/v1/information/rerankers-models.json")
        .then(response => response.data);
    return rerankersPromise;
}

export function getDefaultReranker(rerankers) {
    return rerankers.find(reranker => reranker.isDefault);
}

export function getReranker(rerankers, name) {
    if (name === "smart") {
        return getDefaultReranker(rerankers);
    }
    return rerankers.find(reranker => reranker.name === name);
}
